const CARD_BRANDS = {
    "american-express": "amex",
}
export default CARD_BRANDS